import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        brand: {
            brand: '',
            post: '',
            card: true

        },
        ost: []
    },
    getters: {
        getBrand(state) {
            return state.brand
        },
        getOst(state) {
            return state.ost
        }
    },
    mutations: {
        setBrand(state, obj) {
            state.brand = obj
        },
        clearBrand(state, obj) {
            state.brand = obj
        },
        setOst(state, ost) {
            state.ost = ost
        }
    },
    actions: {
        loadOst({ commit }) {
            Vue.http.get('1.json')
                .then(res => {
                    let ost = res.body
                    commit('setOst', ost)
                })
        }
    }
}